import { render, staticRenderFns } from "./StopScreeningPrematureModal.vue?vue&type=template&id=799853bb&"
import script from "./StopScreeningPrematureModal.vue?vue&type=script&lang=js&"
export * from "./StopScreeningPrematureModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports